import { useNavigate } from 'react-router-dom';
import { CreditCard, MessageCircle, FlaskConical, Info } from 'lucide-react';
import { govPageContainer, GOV_TYPE } from '../ui/PatientUIGovernor';

/**
 * Honest lab-payments surface.
 *
 * There is NO online payment integration for lab bills: no gateway, no
 * server-side payment request list for patients. Labs share bills into your
 * chat (MyChat) and collect payment at the lab or through their own UPI
 * details. The previous version of this page rendered GPay/PhonePe/Paytm
 * buttons that launched nothing and marked bills "PAID" without any money
 * moving — that payment theater is deliberately gone.
 */
export default function PatientLabPayments() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6" style={govPageContainer()}>
      <div>
        <h1 className="flex items-center gap-2" style={GOV_TYPE.pageTitle}>
          <CreditCard className="w-6 h-6 text-teal-600" /> Lab Bills &amp; Payments
        </h1>
        <p className="text-sm text-gray-500 mt-1">How lab bills work on NeoHealthCard</p>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 flex gap-3">
        <Info className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
        <div className="text-sm text-amber-800 leading-relaxed">
          <p className="font-semibold mb-1">Online payment for lab bills is not available yet.</p>
          <p>
            Lab bills are settled <strong>directly with the lab</strong> — at the counter during your
            visit, or via the payment details the lab shares with you. This app never simulates a
            payment or marks a bill paid on its own.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <button onClick={() => navigate('/patient/my-chat')}
          className="card p-4 text-left hover:shadow-md transition-shadow">
          <MessageCircle className="w-5 h-5 text-teal-600 mb-2" />
          <p className="text-sm font-semibold text-gray-900">Bills shared by your lab</p>
          <p className="text-xs text-gray-500 mt-1">
            When a lab shares a bill with you, it arrives in your chat with that lab — open My Chat to view it.
          </p>
        </button>
        <button onClick={() => navigate('/patient/lab/appointments')}
          className="card p-4 text-left hover:shadow-md transition-shadow">
          <FlaskConical className="w-5 h-5 text-blue-600 mb-2" />
          <p className="text-sm font-semibold text-gray-900">Your lab bookings</p>
          <p className="text-xs text-gray-500 mt-1">
            See your booked tests and their status. Payment is collected by the lab at your visit.
          </p>
        </button>
      </div>
    </div>
  );
}
